import React, { useEffect, useRef, useState } from 'react'
import GenericFormHeaderComponent from '../../../genericComponents/forms/GenericFormHeaderComponent'
import { convertCamelCase } from '../../../helper/genericFunction';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import GenericSpinnerLoader from '../../../loaders/GenericSpinnerLoader';
import { parseJwt } from '../../../helper/genericFunction';
import NoDataFound from '../../../genericComponents/NoDataFound';
import Icons from '../../../assets/icons';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import ImageUpload from '../create/product/ImageUpload';
import GenericViewDetailsComponent from '../../../genericComponents/viewDetails/GenericViewDetailsComponent';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { getPermissionKey } from '../../../helper/permissions';
import { BookImage, ChevronDown, FileText, HandCoins, ImageIcon, ReceiptText, Star, ThumbsDown, ThumbsUp, User } from 'lucide-react';
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import { Tooltip } from 'antd';
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer, Sector } from "recharts";
import { motion } from 'framer-motion';
import moment from 'moment';


const ViewProductDetailsV2 = (props) => {
    const uType = parseJwt(sessionStorage.getItem('token')).uType?.toUpperCase() || "ENT";
    const {
        closeModal,
        viewPageType = "product",
        selectedData = {},
        permissionsObj = null
    } = props;

    const displayKey = `isDisplay${uType == "ENT" ? "Retailer" : "Vendor"}`

    const dispatch = useDispatch();
    const getProductDetailData = useSelector(state => state?.digicatStore?.getProductDetailData);
    const loadFabricData = useSelector(state => state?.digicatStore?.loadFabricData);
    const loadCostsheetData = useSelector(state => state?.digicatStore?.loadCostsheetData);
    const getDigicatFormSettingsData = useSelector(state => state?.administrationStore?.getDigicatFormSettingsData);
    const getTableComponentFifthListData = useSelector(state => state?.generalStore?.getTableComponentFifthListData);
    const getPurchaseOtbData = useSelector(state => state?.generalStore?.getPurchaseOtbData);
    const getProductFeedbackData = useSelector(state => state?.administrationStore?.getProductFeedbackData);

    // State : To store the current tab
    const [formSettings, setFormSettings] = useState({});
    const [fabricFormSettings, setFabricFormSettings] = useState({});
    const [costSheetFormSettings, setCostSheetFormSettings] = useState({})

    // State: To store the current expanded fabric data
    const [expandedFabric, setExpandedFabric] = useState(null);
    const [fabricFocusedRow, setFabricFocusedRow] = useState(null);

    // State : To store the images data
    const [imagesData, setImagesData] = useState({});
    const [responseData, setResponseData] = useState(null);

    // State : To store the product data and fabric data
    const [productData, setProductData] = useState(null)
    const [fabricData, setFabricData] = useState(null)
    const [costsheetData, setCostsheetData] = useState([])
    const [feedbackData, setFeedbackData] = useState([])
    const [activeParentTab, setActiveParentTab] = useState('productDetailsSection');
    const [isManualScrolling, setIsManualScrolling] = useState(false);

    const [currentCostSheet, setCurrentCostSheet] = useState(null);
    const [customerSatisfactionData, setCustomerSatisfactionData] = useState({})
    const [currentDropdownValue, setCurrentDropdownValue] = useState(null);
    const [activeChart, setActiveChart] = useState({
        chart: null,
        index: null
    })

    const [isLikeChecked, setIsLikeChecked] = useState(false);
    const [isDislikeChecked, setIsDislikeChecked] = useState(false);

    const scrollableContainerRef = useRef(null)

    // handle : the repsonse of the product details api for the product tab
    useEffect(() => {
        if (getProductDetailData?.isSuccess) {
            setProductData(getProductDetailData?.data?.resource?.data || {});
            setImagesData((prevState) => {
                return {
                    ...prevState,
                    product: updateMediaData("product", getProductDetailData?.data?.resource?.data || {})
                }
            })
        }
    }, [getProductDetailData?.isSuccess])

    const constructJson = (arr, keyToStringify) => {
        return arr.map(obj => {
            let newObj = { ...obj };
            if (obj[keyToStringify] !== undefined) {
                newObj[keyToStringify] = JSON.stringify(obj[keyToStringify]);
            }
            return newObj;
        });
    }

    // Handle the response of the fabric details api
    useEffect(() => {
        if (loadFabricData?.isSuccess) {
            let data = constructJson(loadFabricData?.data?.resource, "constructionJson");
            setFabricData(data || []);
            if (loadFabricData?.data?.resource?.length > 0) {
                setFabricFocusedRow(data?.[0]);
                setExpandedFabric(data?.[0]);
            }
        }
    }, [loadFabricData?.isSuccess])

    // Handle : The response of the costsheet details api
    useEffect(() => {
        if (loadCostsheetData?.isSuccess) {
            let data = ["DRAFTED", "SUBMITTED", "REQUESTED"]?.includes(props.activeTab) ? loadCostsheetData?.data?.resource?.[0] : loadCostsheetData?.data?.resource?.find(item => item?.costSheetNo === selectedData?.costSheetNo);
            setCurrentCostSheet(data);
            setCostsheetData(data || []);
            setResponseData(loadCostsheetData?.data?.resource || {});
        }
    }, [loadCostsheetData?.isSuccess])

    useEffect(() => {
        if (getProductFeedbackData?.isSuccess) {
            let data = getProductFeedbackData?.data?.resource?.data || [];
            // let totalRating = getProductFeedbackData?.data?.resource?.totalRecord || [];
            
            // Calculate rating distribution
            const ratingCounts = {
                5: 0,
                4: 0,
                3: 0,
                2: 0,
                1: 0
            };
                        
            // Count ratings and calculate total
            data.forEach(item => {
                const rating = item?.surveyFeedbackSubmitJson?.Rating;
                if (rating && ratingCounts.hasOwnProperty(rating)) {
                    ratingCounts[rating]++;
                }
            });
            
            const totalRecords = data?.length || 0;
            
            // Count likes and dislikes
            const voteCounts = {
                'Like': 0,
                'Dislike': 0
            };
            
            data.forEach(item => {
                const vote = item?.surveyFeedbackSubmitJson?.vote;
                if (vote && voteCounts.hasOwnProperty(vote)) {
                    voteCounts[vote]++;
                }
            });
            
            // Create chart data with counts (not percentages)
            const ratingChartData = [
                {
                    name: "5 Stars",
                    value: ratingCounts[5],
                    count: ratingCounts[5],
                    color: '#00B894',
                    rating: 5
                },
                {
                    name: "4 Stars",
                    value: ratingCounts[4],
                    count: ratingCounts[4],
                    color: '#85CE61',
                    rating: 4
                },
                {
                    name: "3 Stars",
                    value: ratingCounts[3],
                    count: ratingCounts[3],
                    color: '#F6C621',
                    rating: 3
                },
                {
                    name: "2 Stars",
                    value: ratingCounts[2],
                    count: ratingCounts[2],
                    color: '#FF7D22',
                    rating: 2
                },
                {
                    name: "1 Star",
                    value: ratingCounts[1],
                    count: ratingCounts[1],
                    color: '#FD3757',
                    rating: 1
                }
            ].filter(item => item.value > 0); // Only show ratings with data
            
            // Create like/dislike chart data with counts
            const likeDislikeChartData = [
                {
                    name: "Likes",
                    value: Math.round((voteCounts['Like'] / totalRecords) * 100),
                    count: voteCounts['Like'],
                    color: '#51B850'
                },
                {
                    name: "Dislikes",
                    value: Math.round((voteCounts['Dislike'] / totalRecords) * 100),
                    count: voteCounts['Dislike'],
                    color: '#FD3757'
                }
            ]
            // ].filter(item => item.value > 0);
            
            let transformedData = {
                comments: data,
                ratingData: ratingChartData,
                likeDislikeData: likeDislikeChartData,
                totalRecords: totalRecords,
            }
            setFeedbackData(transformedData);
        }
    }, [getProductFeedbackData?.isSuccess])

    useEffect(() => {
        if (getDigicatFormSettingsData?.isSuccess) {
            setFormSettings(getDigicatFormSettingsData?.data?.resource || {});
        }
        if (getTableComponentFifthListData?.isSuccess) {
            setFabricFormSettings(getTableComponentFifthListData?.data?.resource || {});
        }
        if (getPurchaseOtbData?.isSuccess) {
            setCostSheetFormSettings(getPurchaseOtbData?.data?.resource || {});
        }
    }, [getDigicatFormSettingsData?.isSuccess, getTableComponentFifthListData?.isSuccess, getPurchaseOtbData?.isSuccess])

    useEffect(() => {
        getTableData();
    }, [])

    // Whenever the focused fabric row changes then update the fabric image
    useEffect(() => {
        setImagesData((prevState) => {
            return {
                ...prevState,
                fabric: updateMediaData("fabric", fabricFocusedRow)
            }
        })
        console.log("this is the images data ", updateMediaData("fabric", fabricFocusedRow))
    }, [fabricFocusedRow])

    // make parent tabs active as user scrolls to the sections
    useEffect(() => {
        const handleScroll = () => {
            if (isManualScrolling) return; // 👈 Don't update active tab during manual scroll

            const sections = ['productDetailsSection', 'fabricDetailsSection', 'costsheetDetailsSection', 'feedbackSection'];
            let currentSection = null;

            sections.forEach((id) => {
                const section = document.getElementById(id);
                if (section) {
                    const rect = section.getBoundingClientRect();
                    if (rect.top <= 330 && rect.bottom >= 100) {
                        currentSection = id;
                    }
                }
            });

            if (currentSection) {
                setActiveParentTab(currentSection);
            }
        };

        const container = scrollableContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll, { passive: true });
        }

        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, [isManualScrolling]);


    // Function : To update the media data and set the media data inside the state
    const updateMediaData = (tab, data, updatedMediaData = {}) => {
        switch (tab) {
            case "product": {
                let keys = ["imageUrlFront", "imageUrlBack", "imageUrlSide", "imageUrlDetailed", "imageUrlLook", "videoUrl", "rawImage1", "rawImage2", "pdfUrl", "teckPackUrl"];
                keys?.map(key => {
                    if (data?.[key]) {
                        updatedMediaData[key] = {
                            "url": data?.[key != "videoUrl" ? key == "teckPackUrl" ? "teckPack" : key == "pdfUrl" ? "pdf" : `${key}Url` : "video"] || "",
                            "filePath": data?.[key]
                        }
                    }
                })
                break;
            }
            case "fabric": {
                ["fabricImage"]?.map(key => {
                    if (data?.[key]) {
                        updatedMediaData[key] = {
                            "url": data?.[`${key}Url`] || "",
                            "filePath": data?.[key]
                        }
                    }
                })
            }
        }

        return updatedMediaData;
    }

    // Funcion : To render the header componernt
    const renderHeaderComponent = () => {
        return <GenericFormHeaderComponent
            headerClassName='border-b border-borderSlateGrey'
            label={{
                "contentPrimary": <><LanguageTranslator>{convertCamelCase(viewPageType)}</LanguageTranslator> <LanguageTranslator>Details</LanguageTranslator> : {selectedData?.productId || '-'}</>,
                "contentSecondry": `View complete ${viewPageType} details for selected ${viewPageType}.`
            }}
            rowEndComponent={viewPageType == "product" && renderTabsSection()}
            closeModal={closeModal}
        />
    }

    const getTableData = () => {
        let payloadKey = {
            "product": "productCatalogue",
            "fabric": "fabric",
            "costsheet": "costSheet",
        }
        dispatchHandler(dispatch, "getProductDetailRequest", { "productId": selectedData?.productId }, permissionsObj ?? getPermissionKey("purchase", "product", "copy"));
        dispatchHandler(dispatch, "loadFabricRequest", {
            "dataValue": viewPageType != "product" ? selectedData?.fabricCode || "" : selectedData?.productId || "",
            "isGetProductFabric": viewPageType == "product" ? true : false,
        }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
        dispatchHandler(dispatch, "loadCostsheetRequest", {
            "dataValue": viewPageType != "product" ? selectedData?.costSheetNo || "" : selectedData?.productId || "",
            "isProductCostSheet": viewPageType == "product" ? true : false,
        }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
        dispatchHandler(dispatch, "getDigicatFormSettingsRequest", {
            type: "productCatalogue"
        }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
        dispatchHandler(dispatch, "getTableComponentFifthListRequest", {
            type: "fabric",
            apiUrl: "/system/config/get/tenant/form/setting"
        }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
        dispatchHandler(dispatch, "getPurchaseOtbRequest", {
            type: "costSheet",
            apiUrl: "/system/config/get/tenant/form/setting"
        }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))

        dispatchHandler(dispatch, "getProductFeedbackRequest", {
            productId: selectedData?.productId || "",
        }, getPermissionKey("purchase", "product", "view"))

    }

    // Function : To render the details of the product;
    const renderDetails = () => {

        if (getProductDetailData?.isLoading || loadFabricData?.isLoading || loadCostsheetData?.isLoading) {
            return <div className='h-[calc(100%-80px)] w-full flex items-center justify-center'><GenericSpinnerLoader /></div>
        }

        // switch (currentTab) {
        //     case "product": {
        //         return renderProductDetails();
        //     }
        //     case "fabric": {
        //         return renderFabricDetails();
        //     }
        //     case "costsheet": {
        //         return renderCostsheetDetails()
        //     }
        // }

        return <>
            {renderProductDetails()}
            {fabricData?.length !== 0 && renderFabricDetails()}
            {costsheetData?.length !== 0 && renderCostsheetDetails()}
            {(uType === 'ENT' && feedbackData?.totalRecords > 0) && renderFeedbackDetails()}
        </>
    }

    const isDisplayKey = (key, tab = "") => {
        // console.log("jey", formSettings, key);
        return tab == "costsheet" ? costSheetFormSettings?.[key]?.[displayKey] == 1 : tab == "fabric" ? fabricFormSettings?.[key]?.[displayKey] == 1 : formSettings?.[key]?.[displayKey] == 1;
    }

    // State : To check if the keys is amount
    const isAmount = (key) => {
        if ((responseData?.[0]?.tradeDiscountFormat?.toLowerCase() == "rupees" ? ["totalSupplierCost", "tradeDiscount"] : ["totalSupplierCost"])?.includes(key)) {
            return true;
        }
        return false;
    }

    const isPercentage = (key) => {
        if ((responseData?.[0]?.tradeDiscountFormat?.toLowerCase() == "rupees" ? [] : ["tradeDiscount"])?.includes(key)) {
            return true;
        }
        return false;
    }

    // Function : To provide the current total supplier cost
    const getCurrentTotalSupplierCost = (type) => {
        let totalCost = 0;
        let unitCostKey = uType == "ENT" ? "retailerUnitCost" : "vendorUnitCost";
        costsheetData?.materialDets?.map(item => {
            totalCost += (Number(item?.[unitCostKey] || "") * Number(item?.["qty"] || ""));
        })
        return totalCost?.toFixed(2);
    }

    const getCurrentRowCostPercentage = (item) => {
        let unitCostKey = uType == "ENT" ? "retailerUnitCost" : "vendorUnitCost";
        return (Number((Number(item?.[unitCostKey] || "") * Number(item?.["qty"] || "")) / Number(getCurrentTotalSupplierCost("original") || "") || "") * 100)?.toFixed(2);
    }


    // Function: To combine the data based on the material type
    const getCostSheetDataCombinedByMaterialType = () => {
        let obj = {};

        costsheetData?.materialDets?.map(item => {
            if (!obj?.[item?.materialType]) {
                obj[item.materialType || ""] = {};
                obj[item.materialType || ""].data = [];
            }
            obj[item.materialType || ""].data.push(item);
            obj[item.materialType || ""]["vendorProposedCost"] = Number(obj[item.materialType || ""]?.["vendorProposedCost"] || 0) + Number(item?.vendorProposedCost || 0)
            obj[item.materialType || ""]["proposedCost"] = Number(obj[item.materialType || ""]?.["proposedCost"] || 0) + Number(item?.proposedCost || 0)
        })

        return obj;
    }


    // Function : To render the cost sheet details
    const renderCostsheetDetails = () => {
        let modifiedData = getCostSheetDataCombinedByMaterialType(costsheetData);
        console.log("modified data", modifiedData);
        let keys = ["materialName", "qty", "vendorUnitCost", "vendorProposedCost", "retailerUnitCost", "proposedCost", "percentage"];
        return <div className={`dfvd-costsheet relative pt-[12px] pb-[.8rem] mt-[28px] mb-[12px] border border-borderSlateGrey rounded-[5px] ${costsheetData?.length == 0 ? 'no-costsheet-data' : ''}`} id='costsheetDetailsSection'>

            <div className='flex items-end justify-between gap-5'>
                <div className={`px-[15px] ${costsheetData?.length == 0 ? '' : 'pb-[5rem] flex items-center gap-2'}`}>
                    <LanguageTranslator tag='h2' className='mb-0 text-base font-semibold text-fontBlack'>Cost Sheet Details</LanguageTranslator>
                    {costsheetData?.length !== 0 && <div className='px-2.5 py-1 bg-[#F0F3F6] rounded-full'><h2 className='text-xs font-semibold text-[#67768E] mb-0'>Cost Sheet No : {costsheetData?.costSheetNo || '-'}</h2></div>}
                </div>

                {responseData?.length > 1 && uType == "ENT" && <div className='mr-4'>
                    <GenericInput
                        value={currentCostSheet?.costSheetNo}
                        inputKey="costSheetNo"
                        iconRight={<Icons.DownArrowNew />}
                        customValue={() => currentCostSheet?.costSheetNo || ""}
                        type="dropdown"
                        label="Choose Costsheet"
                        inputProps={() => ({
                            modalMainClass: '!z-[3]',
                            headerKeys: {
                                "costSheetNo": "Costsheet No."
                            },
                            itemKeys: {
                                "costSheetNo": ["costSheetNo"],
                            },
                            getListData: () => responseData || [],
                        })}
                        onChange={(val) => {
                            setCurrentCostSheet(val);
                            setCostsheetData(val);
                        }}
                    />
                </div>}
            </div>

            {/* Render the top level cost sheet details */}
            {costsheetData?.length == 0 ? <div className='pb-8'><NoDataFound primaryText="No Cost Sheet Found!" /></div> : <><div className='dfvdc-det !top-[48px] !left-[5px]'>
                {["costSheetName", "totalSupplierCost", "tradeDiscount", "tradeMargin", "marginType"]?.map(key => {
                    if (isDisplayKey(key, "costsheet")) {
                        return <div className='dfvdcd'>
                            <LanguageTranslator tag='label' className='!text-[11px] !font-medium !text-[#74767A] !mb-1'>{costSheetFormSettings?.[key]?.["displayName"]}</LanguageTranslator>
                            <p className='rounded-[3px] min-w-[100px]'>{isAmount(key) && <span>&#8377;</span>} {costsheetData?.[key] || "-"} {isPercentage(key) && <span> % </span>}</p>
                        </div>
                    }
                })}
            </div>

                {/* Render the actual table for the costsheet */}
                <div className='px-[15px] h-full overflow-auto'>
                    {Object.keys(modifiedData || {})?.length == 0 && <div className='table-v2 !h-auto'><table>
                        <thead>
                            <tr>
                                {keys?.map((key, index) => {
                                    return isDisplayKey(key, "costsheet") && <th key={`header-${index}`}><LanguageTranslator>{costSheetFormSettings?.[key]?.displayName}</LanguageTranslator></th>
                                })}
                            </tr>
                        </thead>
                        <tbody className='!border-0'>
                            <tr>
                                <td colSpan='100' className='!border-0'>
                                    <LanguageTranslator tag='p' className='td-no-data'>No Data Found!</LanguageTranslator>
                                </td>
                            </tr>
                        </tbody>
                    </table></div>}

                    {
                        Object.keys(modifiedData || {})?.map((key, index) => {
                            return <div className={`table-v2 !h-auto ${Object.keys(modifiedData || {})?.length > 1 ? 'rounded-b-none last:rounded-[5px]' : ''} ${index > 0 ? '!border-t-0 !rounded-t-none' : ''}`}>
                                <table>
                                    <thead>
                                        {index === 0 && <tr>
                                            {keys?.map((key, index) => {
                                                return isDisplayKey(key, "costsheet") && <th key={`header-${index}`}><LanguageTranslator>{costSheetFormSettings?.[key]?.displayName}</LanguageTranslator></th>
                                            })}
                                        </tr>}
                                        <tr>
                                            <td colSpan={'100%'} className='px-3 h-[32px] align-middle'>
                                                <div className='flex justify-between items-center gap-3'>
                                                    <p className='mb-0 text-xs font-semibold text-[#111D31]'>{key}</p>
                                                    <div className='flex items-center gap-3'>
                                                        <div className='flex items-center gap-3'>
                                                            <div className='flex items-center gap-1'>
                                                                <Icons.VendorProposedCost />
                                                                <p className='mb-0 text-[11px] font-semibold text-[#6C6C6C]'>Total Vendor Proposed Cost : <span className='text-xs font-medium text-[#111D31]'>&#8377; {modifiedData?.[key]?.vendorProposedCost || "NA"}</span></p>
                                                            </div>
                                                            <div className='h-[10px] w-[1px] shrink-0 bg-borderSlateGrey'></div>
                                                            <div className='flex items-center gap-1'>
                                                                {/* <HandCoins size={14} color='#71819B' /> */}
                                                                <HandCoins size={14} color='#71819B' strokeWidth={1.75} />
                                                                <p className='mb-0 text-[11px] font-semibold text-[#6C6C6C]'>Total Retailed Proposed Cost : <span className='text-xs font-medium text-[#111D31]'>&#8377; {modifiedData?.[key]?.proposedCost || "NA"}</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            modifiedData?.[key]?.data?.map((item, index) => (
                                                <tr key={`row-${index}`} className='border-b border-r-borderSlateGrey last:border-b-0'>
                                                    {keys?.map((key, subIndex) => (
                                                        isDisplayKey(key, "costsheet") && (
                                                            <td className='w-[calc(100%/7)]' key={`head-${subIndex}`}>
                                                                <label>{key == "percentage" ?
                                                                    getCurrentRowCostPercentage(item)
                                                                    : item?.[key]}
                                                                </label>
                                                            </td>
                                                        )
                                                    ))}
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        })
                    }
                </div>
            </>}
        </div>
    }

    useEffect(() => {
        setActiveChart({
            chart: null,
            index: null,
        });
    }, [isLikeChecked, isDislikeChecked]);

    const renderFeedbackDetails = () => {

        const ratingData = {
            "5 Stars": "#00B894",
            "4 Stars": "#85CE61",
            "3 Stars": "#F6C621",
            "2 Stars": "#FF7D22",
            "1 Star": "#FD3757",
            "1 Stars": "#FD3757",
        };

        const averageRating = feedbackData?.ratingData?.reduce((acc, item) => {
            return acc + (item?.rating * item?.count);
        }, 0) / feedbackData?.totalRecords || 0;

        const formattedAverageRating =
            averageRating % 1 === 0
                ? averageRating
                : Number(averageRating.toFixed(1));

        const CustomerSatisfactionChartTooltip = ({ active, payload }) => {
            const rating = payload[0]?.payload?.rating;
            const count = payload[0]?.payload?.count;
            const percent = feedbackData?.totalRecords ? ((count / feedbackData.totalRecords) * 100).toFixed(1) : 0;
            if (active && payload && payload.length) {
                return (
                    <motion.div initial={{scale: .9, opacity: 0}} animate={{scale: 1, opacity: 1}} exit={{scale: .9, opacity: 0}} transition={{duration: .1}} style={{boxShadow: '0px 4.4px 4.4px 0px #00000040'}} className={`bg-white p-[12px] rounded-[10px] border border-[#EBEBEB]`}>
                        <div className='flex items-center gap-1.5 mb-2'>
                            <p className="mb-0 text-base font-semibold text-fontBlack">{count} rating{count > 1 ? 's' : ''}</p>
                            <span className='text-[11px] font-medium text-[#8D99AC]'>({percent}%)</span>
                        </div>
                        <p className='mb-0 text-[11px] font-medium text-[#8D99AC] mb-1'>Rating: {rating} Star{rating !== 1 ? 's' : ''}</p>
                    </motion.div>
                );
            }
            return null;
        };

        const CustomerSatisfactionChartTooltip2 = ({ active, payload }) => {
            const count = payload[0]?.payload?.count;
            const percent = feedbackData?.totalRecords ? ((count / feedbackData.totalRecords) * 100).toFixed(1) : 0;
            if (active && payload && payload.length) {
                return (
                    <motion.div initial={{scale: .9, opacity: 0}} animate={{scale: 1, opacity: 1}} exit={{scale: .9, opacity: 0}} transition={{duration: .1}} style={{boxShadow: '0px 4.4px 4.4px 0px #00000040'}} className={`bg-white p-[12px] rounded-[10px] border border-[#EBEBEB]`}>
                        <div className='flex items-center gap-1.5 mb-2'>
                            <p className="mb-0 text-base font-semibold text-fontBlack">{count} response{count > 1 ? 's' : ''}</p>
                            <span className='text-[11px] font-medium text-[#8D99AC]'>({percent}%)</span>
                        </div>
                        <p className='mb-0 text-[11px] font-medium text-[#8D99AC]'>{payload[0]?.name}</p>
                    </motion.div>
                );
            }
            return null;
        };

        // const getEmoji = {
        //         5: <Icons.RatingEmoji5/>,
        //         4: <Icons.RatingEmoji4/>,
        //         3: <Icons.RatingEmoji3/>,
        //         2: <Icons.RatingEmoji2/>,
        //         1: <Icons.RatingEmoji1/>,
        //     }

        const likeDislikeRatingData = {
            "Likes": "#51B850",
            "Dislikes": "#FD3757",
        };

        const getName = {
            "5 Stars": "Excellent",
            "4 Stars": "Very Good",
            "3 Stars": "Good",
            "2 Stars": "Fair",
            "1 Star": "Poor",
            "1 Stars": "Poor",

        };

        // const onPieEnter = (_, index) => {
        //     setPieChartsActiveIndex(index)
        // }

        const dropdownData = {
            "hl1_name": { "value": "Division", key: "hl1_name" },
            "hl2_name": { "value": "Section", key: "hl2_name" },
            "hl3_name": { "value": "Department", key: "hl3_name" },
            "hl4_name": { "value": "Article", key: "hl4_name" },
        }

        function formatCommentTime(creationTime) {
            const now = moment();
            const commentTime = moment(creationTime);
            const diffMinutes = now.diff(commentTime, "minutes");
            const diffDays = now.diff(commentTime, "days");
            
            if (diffMinutes < 60) {
                return `${diffMinutes} min ago`;
            } else if (diffMinutes < 1440) {
                const hours = Math.floor(diffMinutes / 60);
                return `${hours} hour${hours > 1 ? "s" : ""} ago`;
            } else if (diffDays < 3) {
                return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
            } else {
                return commentTime.format("DD MMM YYYY, hh:mm A");
            }
        } 

        return <div 
            id='feedbackSection'
            className='mt-[32px] mb-[20px] min-h-[500px]'
            >
                <LanguageTranslator tag='h2' className='mb-3 text-base font-semibold text-fontBlack'>Product Feedback</LanguageTranslator>
                <div className='mb-[16px] flex border border-borderSlateGrey rounded-[10px]'>
                    <div onMouseLeave={() =>
                            setActiveChart({
                                chart: null,
                                index: null,
                            })
                        } className='py-3 pr-8 pl-4 w-[55%] h-full flex items-center justify-between border-r border-borderSlateGrey'>
                        {/* {console.log('customerSatisfactionData', customerSatisfactionData)} */}
                        <ResponsiveContainer width="35%" height={200} minWidth={180}>  {/* 80% of 250 */}
                            <PieChart>
                                <Pie
                                    activeIndex={
                                        activeChart.chart === 'rating'
                                            ? activeChart.index
                                            : null
                                    }
                                    data={feedbackData?.ratingData}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={52} // Reduced to 80% of 65
                                    outerRadius={85} // Reduced to 80% of 100
                                    cornerRadius={5}
                                    paddingAngle={1.5}
                                    onMouseEnter={(_, index) =>
                                        setActiveChart({
                                            chart: 'rating',
                                            index,
                                        })
                                    }
                                    onMouseLeave={() =>
                                        setActiveChart({
                                            chart: null,
                                            index: null,
                                        })
                                    }
                                >
                                    {feedbackData?.ratingData?.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                {/* Custom Tooltip */}
                                <RechartsTooltip key={'chartTooltip'} active={activeChart.chart === "rating"} content={<CustomerSatisfactionChartTooltip />} />
                                {feedbackData?.totalRecords !== undefined && 
                                <g>
                                    <text 
                                        x="50%" 
                                        y="45%" 
                                        textAnchor="middle" 
                                        dominantBaseline="middle" 
                                        className="text-xs font-medium fill-[#797F87]"
                                    >
                                        <LanguageTranslator>Total Rating</LanguageTranslator>
                                    </text>
                                    <text 
                                        x="50%" 
                                        y="58%" 
                                        textAnchor="middle" 
                                        dominantBaseline="middle" 
                                        className="text-[28px] font-bold fill-fontBlack"
                                    >
                                        {feedbackData?.totalRecords}
                                    </text>
                                </g>
                                }
                            </PieChart>
                        </ResponsiveContainer>
                        <div className='ml-2.5 h-full flex flex-col items-center justify-center text-center'>
                            <Star className='mb-1.5' size={22} color='#F6C621' fill='#F6C621' />
                            <p className='mb-1.5 text-base font-semibold text-fontBlack'>{formattedAverageRating}</p>
                            <p className='mb-0 text-xs font-medium text-[#797F87]'>Average <br/>Rating</p>
                        </div>
                        <div className='space-y-6 ml-3.5'>
                            {Array.from({length: 5})?.map((item, index) => (
                                <div className='flex items-center gap-1'>
                                    <div style={{ borderColor: ratingData[`${5 - index} Stars`] || '#ccc' }} className='mb-0 mr-1.5 border-[5px] h-[14px] aspect-square bg-white rounded-full whitespace-nowrap text-sm font-semibold'></div>
                                    {Array.from({length: 5 - index})?.map((_, subIndex) => {
                                        const ratingValue = 5 - index;
                                        return (
                                            <Star size={12} color='#F6C621' fill='#F6C621' />
                                        )
                                    })}
                                    
                                    {Array.from({length: index})?.map((_, subIndex) => {
                                        const ratingValue = index;
                                        return (
                                            <Star size={12} color='#EDF1F5' fill='#EDF1F5' />
                                        )
                                    })}
                                </div>
                            ))}
                        </div>
                        <div className='space-y-3 ml-3'>
                            {Array.from({length: 5})?.map((item, index) => {
                                const percentage = feedbackData?.totalRecords ? ((feedbackData?.ratingData?.find(r => (5-index) > 1 ? r.name === `${5 - index} Stars` : r.name === `${5 - index} Star`)?.count || 0) / feedbackData.totalRecords) * 100 : 0;
                                return (
                                <div className='flex items-center gap-1.5'>
                                    {/* <p className='mb-0'>1</p> */}
                                    <p className='m-[0] p-[0] leading-[initial] text-base font-semibold text-[#111D31] ml-2'>{percentage.toFixed(0)}%</p>
                                </div>
                            )})}
                        </div>
                        <div className='space-y-[17px] ml-3'>
                            {Array.from({length: 5})?.map((item, index) => (
                                <div className='flex items-center gap-1.5'>
                                    {/* <p className='mb-0'>1</p> */}
                                    <p className='m-[0] p-[0] leading-[initial] text-[13px] font-medium text-[#111D31] ml-2'>{feedbackData?.ratingData?.find(r => (5-index) > 1 ? r.name === `${5 - index} Stars` : r.name === `${5 - index} Star`)?.count || 0}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div 
                    onMouseLeave={() =>
                        setActiveChart({
                            chart: null,
                            index: null,
                        })
                    }
                    className='pr-5 py-3 w-[45%] h-full flex items-center justify-between'>
                        {/* {console.log('customerSatisfactionData', customerSatisfactionData)} */}
                        <ResponsiveContainer width="50%" height={200}>  {/* 80% of 250 */}
                            <PieChart>
                                <Pie
                                    activeIndex={
                                        activeChart.chart === 'likeDislike'
                                            ? activeChart.index
                                            : null
                                    }                                    
                                    data={feedbackData?.likeDislikeData}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={52} // Reduced to 80% of 65
                                    outerRadius={85} // Reduced to 80% of 100
                                    cornerRadius={5}
                                    paddingAngle={1.5}
                                    // onMouseEnter={(_, index) => {setPieChartsActiveIndex(null); setLikeDislikePieActiveIndex(index)}}
                                    // onMouseLeave={() => {setPieChartsActiveIndex(null); setLikeDislikePieActiveIndex(null)}}
                                    onMouseEnter={(_, index) =>
                                        setActiveChart({
                                            chart: 'likeDislike',
                                            index,
                                        })
                                    }
                                    onMouseLeave={() =>
                                        setActiveChart({
                                            chart: null,
                                            index: null,
                                        })
                                    }
                                >
                                    {feedbackData?.likeDislikeData?.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                {/* Custom Tooltip */}
                                <RechartsTooltip active={activeChart.chart === "likeDislike"} key={'chartTooltip2'} content={<CustomerSatisfactionChartTooltip2 />} />
                                {feedbackData?.totalRecords !== undefined && 
                                <g>
                                    <text 
                                        x="50%" 
                                        y="45%" 
                                        textAnchor="middle" 
                                        dominantBaseline="middle" 
                                        className="text-xs font-medium fill-[#797F87]"
                                    >
                                        <LanguageTranslator>Responses</LanguageTranslator>
                                    </text>
                                    <text 
                                        x="50%" 
                                        y="58%" 
                                        textAnchor="middle" 
                                        dominantBaseline="middle" 
                                        className="text-[28px] font-bold fill-fontBlack"
                                    >
                                        {feedbackData?.totalRecords}
                                    </text>
                                </g>
                                }
                            </PieChart>
                        </ResponsiveContainer>

                        <div className='space-y-8 ml-2 mr-6'>
                            {feedbackData?.likeDislikeData?.map((entry, index) => {
                                // const rating = entry?.rating;
                                // if(likeDislikeRatingData?.[entry?.name]){
                                    return (
                                    // <>
                                    <div key={index} className='flex items-center gap-3'>
                                        {/* <div className='flex-shrink-0 w-[20px] h-[20px] rounded-[4px]' style={{backgroundColor: entry.color}}></div> */}
                                        <div className='flex items-center gap-2 flex-grow'>
                                            {/* <p className={`m-0 font-semibold text-[13px]`} style={{color: likeDislikeRatingData?.[entry?.name]}}>{entry?.name}</p> */}
                                            <p className='m-[0] p-[0] leading-[initial] text-base font-semibold text-fontBlack'>{entry?.value}% <br/><span className='text-[13px] font-medium'>{entry?.count}</span></p>
                                        </div>
                                    </div>
                                    // {/* {feedbackData?.likeDislikeData?.length === 1 && <div className='h-[48px]'></div>}
                                    // </> */}
                                    )
                                // }
                                // return <div></div>;
                            })}

                        </div>
                        <div className='space-y-[56px]'>
                            <div className='px-3 py-1.5 rounded-[4px] flex items-center gap-2 text-white bg-[#51B850] text-[11px] font-medium'>
                                <ThumbsUp size={16} color='white' style={{transform: 'rotateY(180deg)'}}/>
                                <span>Likes</span>
                            </div>
                            <div className='px-3 py-1.5 rounded-[4px] flex items-center gap-2 text-white bg-[#FD3757] text-[11px] font-medium'>
                                <ThumbsDown size={16} color='white'/>
                                <span>Dislikes</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='rounded-[10px] bg-[#FAFBFD] border border-borderSlateGrey'>
                    <div className='px-3 py-3.5 border-b border-borderSlateGrey flex items-center justify-between gap-4'>
                        <h2 className='mb-0 text-base font-semibold text-fontBlack'>Comments & Remarks</h2>
                        <div className='flex items-center gap-5'>
                            <label className={`generic-checkbox ${(!feedbackData?.likeDislikeData?.find(item => item?.name === 'Likes')?.count || feedbackData?.likeDislikeData?.find(item => item?.name === 'Likes')?.count === 0) ? 'checkbox-disabled cursor-not-allowed' : ''}`}>
                                <input
                                    type="checkBox"
                                    id={'like'}
                                    checked={isLikeChecked}
                                    onChange={(e) =>
                                        setIsLikeChecked(!isLikeChecked)
                                    }
                                    name="selectEach"
                                    disabled={(!feedbackData?.likeDislikeData?.find(item => item?.name === 'Likes')?.count || feedbackData?.likeDislikeData?.find(item => item?.name === 'Likes')?.count === 0)}
                                />
                                <span className="checkmark1"></span>
                                <span className='text-xs font-semibold text-[#03B675]'>Liked</span>
                                <span className='ml-1 text-xs font-semibold'>{feedbackData?.likeDislikeData?.find(item => item?.name === 'Likes')?.count || 0}</span>
                            </label>
                            <label className={`generic-checkbox ${(!feedbackData?.likeDislikeData?.find(item => item?.name === 'Dislikes')?.count || feedbackData?.likeDislikeData?.find(item => item?.name === 'Dislikes')?.count === 0) ? 'checkbox-disabled cursor-not-allowed' : ''}`}>
                                <input
                                    type="checkBox"
                                    id={'dislike'}
                                    checked={isDislikeChecked}
                                    onChange={(e) =>
                                        setIsDislikeChecked(!isDislikeChecked)
                                    }
                                    name="selectEach"
                                    disabled={(!feedbackData?.likeDislikeData?.find(item => item?.name === 'Dislikes')?.count || feedbackData?.likeDislikeData?.find(item => item?.name === 'Dislikes')?.count === 0)}
                                />
                                <span className="checkmark1"></span>
                                <span className='text-xs font-semibold text-[#FD3757]'>Disliked</span>
                                <span className='ml-1 text-xs font-semibold'>{feedbackData?.likeDislikeData?.find(item => item?.name === 'Dislikes')?.count || 0}</span>
                            </label>
                        </div>
                    </div>
                    <div className='p-[20px] space-y-6'>
                        {feedbackData?.comments?.filter((item) => {
                                const vote = item?.surveyFeedbackSubmitJson?.vote;

                                // Both checked OR both unchecked → show all
                                if (isLikeChecked === isDislikeChecked) {
                                    return true;
                                }

                                // Only Like checked
                                if (isLikeChecked) {
                                    return vote === "Like";
                                }

                                // Only Dislike checked
                                if (isDislikeChecked) {
                                    return vote === "Dislike";
                                }

                                return true;
                            }
                        ).map((item, index)=>{

                            const now = moment();

                            const daysDiff = now.diff(item?.creationTime, "days");

                            return (
                            <div key={index}>
                                <div className='mb-1.5 flex items-center gap-1.5'>
                                    <div className='p-[1px] bg-[#EDF1F5] rounded-full h-[20px] aspect-square flex items-center justify-center'>
                                        <User size={14} className='shrink-0' />
                                    </div>
                                    <span className='text-xs font-semibold text-fontBlack'>{item?.surveyFeedbackSubmitJson?.name} <span className='text-[11px] font-medium text-[#67768E]'>({item?.surveyFeedbackSubmitJson?.mobileNo})</span></span>
                                </div>
                                <p className='mb-2 text-xs text-[#525676]'>{item?.surveyFeedbackSubmitJson?.comments}</p>
                                <div className='flex items-center justify-between gap-4'>
                                    <div className='flex items-center gap-2.5'>
                                        <div className={`p-[4px] h-[22px] w-[22px] shrink-0 rounded-[4px] flex items-center justify-center ${item?.surveyFeedbackSubmitJson?.vote === 'Like' ? 'bg-[#51B850]' : 'bg-[#FD3757]'}`}>
                                            {
                                                item?.surveyFeedbackSubmitJson?.vote === 'Like' ? (
                                                    <ThumbsUp size={18} color='white' style={{transform: 'rotateY(180deg)'}} />
                                                ) : (
                                                    <ThumbsDown size={18} color='white' />
                                                )
                                            }
                                        </div>
                                        <div className='flex items-center gap-1'>
                                            {Array.from({length: item?.surveyFeedbackSubmitJson?.Rating})?.map((_, subIndex) => {
                                                return (
                                                    <Star size={12} color='#F6C621' fill='#F6C621' />
                                                )
                                            })}
                                            
                                            {Array.from({length: 5 - item?.surveyFeedbackSubmitJson?.Rating})?.map((_, subIndex) => {
                                                return (
                                                    <Star size={12} color='#EDF1F5' fill='#EDF1F5' />
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <Tooltip
                                        overlayClassName='!p-0' 
                                        overlayStyle={{ 
                                        fontSize: '12px',
                                        }}
                                        title={daysDiff < 3 && moment(item?.creationTime).format("DD MMM YYYY, hh:mm A")}
                                    >
                                        <span className='text-[11px] text-[#4A5D7A]'>{formatCommentTime(item?.creationTime)}</span>
                                    </Tooltip>
                                </div>
                            </div>
                        )})}
                    </div>
                </div>
            </div>
    }

    // Function : To render the custom cols 
    const renderCustomColumns = (key, tab) => {
        let tableData = tab == "product" ? productData : fabricData, settings = tab == "product" ? formSettings : fabricFormSettings;
        {
            switch (key) {
                case "fabricComposition": {
                    return <div className='gvmb heading w-full'>
                        <LanguageTranslator tag='div' className='font-semibold text-fontBlack'>{fabricFormSettings?.[key]?.displayName || ""}</LanguageTranslator>

                        <div className='mt-[4px] flex flex-wrap items-center gap-3'>

                        {fabricFocusedRow?.[key]?.split('%')?.length == 0 ? <p style={{ marginRight: "10px" }}>-</p> : (fabricFocusedRow?.[key]?.split('%')?.length > 2 ? fabricFocusedRow?.[key]?.split('%')?.slice(0,2) : fabricFocusedRow?.[key]?.split('%'))?.map(item => (
                            item && <p className='p-bg-grey mb-0'>{item} %</p>
                        ))}


                            {fabricFocusedRow?.[key]?.split('%')?.length > 0 && fabricFocusedRow?.[key]?.split('%')?.length > 2 && <GenericCustomButton
                                type='underline2'
                                label={`+${fabricFocusedRow?.[key]?.split('%')?.length-2}`}
                                tooltip={()=> {
                                    if(!fabricFocusedRow?.[key]?.split('%')?.length) return;
                                return <div className='px-1 py-1'>
                                    <p className='!mb-2 text-xs font-bold text-[#A0A0A0]/60 text-left'>{fabricFocusedRow?.[key]?.split('%')?.length || ''} Colors Available</p>
                                    <div className='flex flex-col flex-wrap max-h-[280px] gap-x-4 gap-y-2 text-left'>{fabricFocusedRow?.[key]?.split('%')?.map((item, index)=> <span className='whitespace-nowrap'>{item || '-'} %</span>) || ''}</div>
                                </div>
                            }}
                                tooltipProps={{
                                    placement: 'right',
                                    overlayInnerStyle:{
                                        width: 'max-content'
                                    }
                                }}
                            />}
                        </div>
                    </div>
                }
                case "fabricColor": {
                    return <div className='gvmb'>
                        <LanguageTranslator tag='label' className='mb-0'>{fabricFormSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        <p>{fabricFocusedRow?.["fabricColor"]?.name}</p>
                    </div>
                }
                case "constructionJson": {
                    return <div className='gvmb'>
                        <LanguageTranslator tag='label' className='mb-0'>{fabricFormSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        <p>{JSON.parse(fabricFocusedRow?.[key] || "")}</p>
                    </div>
                }
                case "fabricDyeYarnCount":
                case "yarnCount": {
                    return <div className='gvmb w-full'>
                        <LanguageTranslator tag='label'>{fabricFormSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        {typeof (fabricFocusedRow?.[key]) == "string" ? <p>{fabricFocusedRow?.[key]}</p> : <p>
                            {fabricFocusedRow?.[key]?.[0] ? fabricFocusedRow?.[key]?.[0] : ""}
                            {fabricFocusedRow?.[key]?.[1] ? " + " + fabricFocusedRow?.[key]?.[1] : ""}
                            {fabricFocusedRow?.[key]?.[2] ? " X " + fabricFocusedRow?.[key]?.[2] : ""}
                            {fabricFocusedRow?.[key]?.[3] ? " + " + fabricFocusedRow?.[key]?.[3] : ""}
                        </p>}
                    </div>
                }
                case "collection":
                case "size": {

                    console.log('fabricData?.[key == "size" ? "libraryDet" : key]', fabricData?.[key == "size" ? "libraryDet" : key])
                    return <div className='gvmb' >
                        <LanguageTranslator tag='label' className='mb-0'>{settings?.[key]?.displayName || ""}</LanguageTranslator>
                        <div className='flex flex-wrap'>
                            {(!tableData?.[key == "size" ? "libraryDet" : key]?.length || tableData?.[key == "size" ? "libraryDet" : key]?.length == 0) ? <p>-</p> : (tableData?.[key == "size" ? "libraryDet" : key]?.length > 2 ? tableData?.[key == "size" ? "libraryDet" : key].slice(0,2) : tableData?.[key == "size" ? "libraryDet" : key])?.map(item => (
                                <p className='p-bg-grey'>{item?.[key == "size" ? "size" : "name"] || "-"}</p>
                            ))}
                            {!(!tableData?.[key == "size" ? "libraryDet" : key]?.length || tableData?.[key == "size" ? "libraryDet" : key]?.length == 0) && tableData?.[key == "size" ? "libraryDet" : key]?.length > 2 && <GenericCustomButton
                                type='underline2'
                                label={`+${tableData?.[key == "size" ? "libraryDet" : key]?.length-2}`}
                                tooltip={()=> {
                                    if(!tableData?.[key == "size" ? "libraryDet" : key]?.length || tableData?.[key == "size" ? "libraryDet" : key]?.length == 0) return;
                                return <div className='px-1 py-1'>
                                    <p className='!mb-2 text-xs font-bold text-[#A0A0A0]/60 text-left'>{tableData?.[key == "size" ? "libraryDet" : key]?.length || ''} {key == "size" ? 'Sizes' : 'Collections'} Available</p>
                                    <div className='flex flex-col flex-wrap max-h-[280px] gap-x-4 gap-y-2 text-left'>{tableData?.[key == "size" ? "libraryDet" : key]?.map((item, index)=> <span className='whitespace-nowrap'>{item?.[key == "size" ? "size" : "name"]}</span>) || ''}</div>
                                </div>
                            }}
                                tooltipProps={{
                                    placement: 'right',
                                    overlayInnerStyle:{
                                        width: 'max-content'
                                    }
                                }}
                            />}
                        </div>
                    </div>
                }
                case "color": {

                    const colorList = (tableData?.["color"] || fabricFocusedRow?.["fabricColor"]?.name) ? 
                            (tableData?.["color"] || fabricFocusedRow?.["fabricColor"]?.name)?.includes('|') ? (tableData?.["color"] || fabricFocusedRow?.["fabricColor"]?.name)?.split('|') : Array.isArray(tableData?.["color"] || fabricFocusedRow?.["fabricColor"]?.name) ? (tableData?.["color"] || fabricFocusedRow?.["fabricColor"]?.name) : null : null;

                    return <div className='gvmb' >
                        <LanguageTranslator tag='label' className='mb-0'>{settings?.[key]?.displayName || ""}</LanguageTranslator>
                        <div className='flex flex-wrap'>
                            {colorList?.length ? (colorList?.length > 2 ? colorList?.slice(0,2) : colorList)?.map(item=>
                                <p className='p-bg-grey'>{item || '-'}</p>
                            ) :
                            <p className='p-bg-grey'>{tableData?.["color"] || fabricFocusedRow?.["fabricColor"]?.name || "-"}</p>}
                            {colorList?.length > 2 && <GenericCustomButton
                                type='underline2'
                                label={`+${colorList?.length-2}`}
                                tooltip={()=> {
                                    if(!colorList?.length) return;
                                return <div className='px-1 py-1'>
                                    <p className='!mb-2 text-xs font-bold text-[#A0A0A0]/60 text-left'>{colorList?.length || ''} Colors Available</p>
                                    <div className='flex flex-col flex-wrap max-h-[280px] gap-x-4 gap-y-2 text-left'>{colorList?.map((item, index)=> <span className='whitespace-nowrap'>{item || '-'}</span>) || ''}</div>
                                </div>
                            }}
                                tooltipProps={{
                                    placement: 'right',
                                    overlayInnerStyle:{
                                        width: 'max-content'
                                    }
                                }}
                            />}
                        </div>
                    </div>
                }
                case 'vendorName': {
                    return <div className='gvmb w-full'>
                        <LanguageTranslator tag='label'>{settings?.[key]?.displayName || ""}</LanguageTranslator>
                        <div className='mt-[4px] flex items-center flex-wrap gap-3'>
                            {/* {formSettings?.[key]?.displayName || ""} */}
                            {
                                (fabricFocusedRow?.["vendorJson"]?.length >2 ? fabricFocusedRow?.["vendorJson"]?.slice(0,2) : fabricFocusedRow?.["vendorJson"])?.map(item => (
                                    <p className='px-1 py-[2px] bg-[#ECECEC]'>{item?.["vendorName"] || "-"}</p>
                                ))
                            }
                            {fabricFocusedRow?.["vendorJson"]?.length > 2 && <GenericCustomButton
                                type='underline2'
                                label={`+${fabricFocusedRow?.["vendorJson"]?.length-2}`}
                                tooltip={()=> {
                                    if(!fabricFocusedRow?.["vendorJson"]?.length) return;
                                return <div className='px-1 py-1'>
                                    <p className='!mb-2 text-xs font-bold text-[#A0A0A0]/60 text-left'>{fabricFocusedRow?.["vendorJson"]?.length || ''} Colors Available</p>
                                    <div className='flex flex-col flex-wrap max-h-[280px] gap-x-4 gap-y-2 text-left'>{fabricFocusedRow?.["vendorJson"]?.map((item, index)=> <span className='whitespace-nowrap'>{item?.["vendorName"] || '-'}</span>) || ''}</div>
                                </div>
                            }}
                                tooltipProps={{
                                    placement: 'right',
                                    overlayInnerStyle:{
                                        width: 'max-content'
                                    }
                                }}
                            />}
                        </div>
                    </div>
                }
            }
        }

    }

    // Function : To check whether a dye-type dependent fabric field should be shown.
    // fabricDyeYarnCount is only relevant for "yarn dyed" and color/fabricColor only for
    // "piece dyed" fabrics. When the fabric's dye type does not match, these fields must
    // not be rendered even if they are enabled (display ON) in the form settings.
    const isFabricConditionalFieldVisible = (key, tab) => {
        if (tab != "fabric") return true;
        let dyeType = fabricFocusedRow?.["fabricDyeType"]?.toString()?.toLowerCase() || "";
        if (key == "fabricDyeYarnCount") return dyeType == "yarn dyed";
        if (key == "color" || key == "fabricColor") return dyeType == "piece dyed";
        return true;
    }

    // Function : To provide the view configuration
    const prepareViewConfiguration = (keys, tab) => {
        let obj = {};
        // The fabric keys to render the data;
        keys?.map(key => {
            if (isDisplayKey(key, tab) && isFabricConditionalFieldVisible(key, tab)) {
                obj[key] = ["fabricDyeYarnCount", "constructionJson", "fabricColor", "yarnCount", "fabricComposition", "color", "size", "collection", "vendorName"]?.includes(key) ? () => renderCustomColumns(key, tab) : tab == "product" ? formSettings?.[key]?.displayName || "" : fabricFormSettings?.[key]?.displayName || "";
            }
        });
        return obj;
    }

    // Function : To render the fabric details 
    const renderFabricDetails = () => {
        if (fabricData?.length == 0) {
            return <div className='dfvb-det !pt-[12px] !px-[15px] !flex !flex-col border border-borderSlateGrey rounded-[5px] mt-[28px]' id='fabricDetailsSection'>
                <h2 className='text-base font-semibold text-fontBlack'>Fabric Details</h2>
                <div className='mb-10'><NoDataFound primaryText="No Fabrics Found!" /></div>
            </div>
        }

        let fabricKeys = prepareViewConfiguration(Object.keys(fabricFormSettings || {}), "fabric");

        return (
            <div className='dfvb-det relative !grid grid-cols-[60%_40%] border border-borderSlateGrey rounded-[5px] mt-[28px]' id='fabricDetailsSection'>
                <LanguageTranslator tag='h2' className='absolute top-0 left-0 z-[2] text-base font-semibold text-fontBlack bg-white rounded-tl p-[12px] w-[60%]'>Fabric Details</LanguageTranslator>
                <div className='dfvbd-fabric !pt-[3rem] h-full !w-full max-h-[456px]'>
                    {fabricData?.map(item => (
                        <div className='dfvbdf-det'>
                            <div className='frd-top !px-[12px] !py-2.5 !items-start'>
                                <div className='flex items-start'>
                                    {item?.fabricImageUrl ?
                                        <div className='frdt-img shrink-0 rounded-[5px] overflow-hidden'>
                                            <img src={item?.fabricImageUrl} />
                                        </div> :
                                        <div className='frdt-img shrink-0'>
                                            <Icons.ImageThumbnail />
                                        </div>
                                    }
                                    <div className='p-lft-10'>
                                        {/* <label>Fabric Code</label> */}
                                        <p className='!mb-1.5 !text-[11px] !font-medium text-fontBlack'>{item?.fabricName}</p>
                                        <div className='px-2.5 py-1 w-fit bg-[#F0F3F6] rounded-[3px]'>
                                            <p className='mb-0 !text-[11px] !font-medium text-fontBlack'>{item?.fabricCode || ""}</p>
                                        </div>
                                    </div>
                                </div>
                                {/* Render the expand collapse toggle button */}
                                {/* <GenericCustomButton
                                        label={expandedFabric?.id === item?.id ? "Collapse Details" : "Expand For Details"}
                                        rightIcon={<Icons.DownArrowNew className={expandedFabric?.id === item?.id && "rotate-180"} />}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (item?.id === expandedFabric?.id) {
                                                setExpandedFabric(null);
                                            } else {
                                                setExpandedFabric(item);
                                                setFabricFocusedRow(item);
                                            }
                                        }}
                                    /> */}
                                <GenericCustomButton
                                    // label={expandedFabric?.id === item?.id ? "Collapse Details" : "Expand For Details"}
                                    rightIcon={<ChevronDown size={16} className={`m-[0] !ml-[0] duration-200 ${expandedFabric?.id === item?.id && "rotate-180"}`} />}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (item?.id === expandedFabric?.id) {
                                            setExpandedFabric(null);
                                        } else {
                                            setExpandedFabric(item);
                                            setFabricFocusedRow(item);
                                        }
                                    }}
                                    className={'mr-1.5 p-[4px] h-[24px] w-[24px] mt-[4px] aspect-square flex items-center justify-center !border-none bg-gray-100 rounded-full'}
                                />
                            </div>
                            {/* <div className='frd-bot flex items-start justify-between'>
                                <p>{item?.fabricName}</p>
                                <CopyContentGenericComponent type={2} content={item?.fabricName} />
                            </div> */}
                            {/* Place to render the expanded details for the fabric row */}
                            {expandedFabric?.id === item?.id && (
                                <div className='dfvbdf-data'>
                                    <GenericViewDetailsComponent
                                        label=""
                                        sections={{
                                            basicDetails: "",
                                        }}
                                        headerKeys={{
                                            "basicDetails": {
                                                "numOfCols": 1,
                                                "keys": fabricKeys,
                                            }
                                        }}
                                        selectedData={fabricFocusedRow}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Render the image section here */}
                <div className='dfvbd-right !min-h-[457px] !h-full !w-full !static !border-none !mt-[0] !pt-[6px]'>
                    {renderImageSection("fabric")}
                </div>
            </div>
        )
    }

    // Function : To render the product details
    const renderProductDetails = () => {
        let basicKeys = ["hl1Name", "hl2Name", "hl3Name", "designGroupNumber", "season", "itemName", "color", "size", "description", "costPrice"];
        let basicDetailsKeys = prepareViewConfiguration(basicKeys, "product");
        let attributeKeys = Object.keys(formSettings || {})?.filter(key => !basicKeys?.includes(key));
        let attributeDetailsKeys = prepareViewConfiguration(attributeKeys, "product");


        return <div className='dfvb-det !grid grid-cols-[58%_42%] border border-borderSlateGrey rounded-[5px]' id='productDetailsSection'>
            <div className={`dfvbd-left h-full !w-full max-h-[456px]`}>
                <GenericViewDetailsComponent
                    label=""
                    sections={{
                        basicDetails: "Basic Details",
                        attributes: "Attributes"
                    }}
                    headerKeys={{
                        "basicDetails": {
                            "numOfCols": 1,
                            "keys": basicDetailsKeys,
                        },
                        "attributes": {
                            "numOfCols": 1,
                            "keys": attributeDetailsKeys,
                        }
                    }}
                    selectedData={productData}
                />
            </div>
            {/* <div className='dfvbd-right w-[45%]'> */}
            <div className='dfvbd-right !h-full !w-full !static !border-none !mt-[0]'>
                {renderImageSection("product")}
            </div>
        </div>
    }

    // Function : To render the image section for the product and fabric
    const renderImageSection = (tab) => {
        // console.log("Image data",imagesData);
        return <ImageUpload
            module={tab}
            viewOnly={true}
            setMediaData={setImagesData}
            mediaData={imagesData?.[tab]}
            heading={tab === 'fabric' ? 'Fabric Images' : ''}
            showTabs={tab === 'fabric' ? false : true}
            formSettings={tab == "product" ? formSettings : fabricFormSettings}
            displayKey={displayKey}
        />
    }

    // Function : To reset all the current states
    const resetStates = () => {
        setFormSettings({});
        setFabricFormSettings({});
        setCostSheetFormSettings({});
        setImagesData(null);
        setFabricFocusedRow(null);
        setExpandedFabric(null);
    }

    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (el && scrollableContainerRef.current) {
            setIsManualScrolling(true); // Lock scroll handling
            setActiveParentTab(id);     // Immediately set active tab manually
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });

            // Unlock after small timeout (depends on your scroll speed)
            setTimeout(() => {
                setIsManualScrolling(false);
            }, 500); // 500ms is safe for most smooth scrolls
        }
    };

    const tabs = [
        { key: 'product', targetId: 'productDetailsSection', label: 'Product', icon: <BookImage size={16} /> },
        { key: 'fabric', targetId: 'fabricDetailsSection', label: 'Fabric', icon: <Icons.FabricIcon className='fabricIcon' height={16} /> },
        { key: 'costsheet', targetId: 'costsheetDetailsSection', label: 'Costsheet', icon: <ReceiptText size={16} /> },
    ];

    
    if(uType === 'ENT') {
        const feedbackTab = { key: 'feedback', targetId: 'feedbackSection', label: 'Feedback', icon: <Icons.FeedbackIcon className='feedbackIcon' height={16} /> }
        tabs.push(feedbackTab);
    }

    // Function : To render the tabs 
    const renderTabsSection = () => {
        return (
            // <div className='dfvb-radio'>
            //     <Radio.Group value={"productDetailsSection"} onChange={(e) => scrollToSection(e.target.value)}>
            //         <Radio.Button value={"productDetailsSection"}><LanguageTranslator>Product Details</LanguageTranslator></Radio.Button>
            //         <Radio.Button value={"fabricDetailsSection"}><LanguageTranslator>Fabric</LanguageTranslator></Radio.Button>
            //         <Radio.Button value={"costsheetDetailsSection"}><LanguageTranslator>Costsheet</LanguageTranslator></Radio.Button>
            //     </Radio.Group>
            // </div>
            <div className="parentTabs flex items-center justify-start bg-[#F6F6F6] p-[4px] rounded-[5px] w-fit">
                {tabs.map((tab) => {
                    console.log('fabricData?.length, costsheetData?.length, tab', fabricData?.length, costsheetData?.length, tab?.key)

                const getTitle = {
                    'fabric': fabricData?.length == 0 ? 'Fabric details are not available' : null,
                    'costsheet': costsheetData?.length == 0 ? 'Costsheet details are not available' : null,
                    'feedback': feedbackData?.totalRecords == 0 ? 'Feedback details are not available' : null,
                }

                const isDisabled = {
                    'fabric': fabricData?.length == 0,
                    'costsheet': costsheetData?.length == 0,
                    'feedback': feedbackData?.totalRecords == 0
                }

                return (
                    <Tooltip
                        overlayClassName='!p-0' 
                        overlayStyle={{ fontSize: '12px' }}
                        overlayInnerStyle={{textAlign: 'center'}}
                        title={getTitle[tab?.key]}
                    >
                        <div
                            className={`cursor-pointer min-w-[80px] h-[36px] px-3 py-1.5 !border-none flex items-center gap-2 text-[15] font-medium hover:opacity-75 ${activeParentTab === tab.targetId ? 'text-primary' : 'text-[#949DA8]'} ${isDisabled[tab?.key] && "!cursor-not-allowed"}`}
                            // onClick={(e) => scrollToSection(tab?.targetId)}
                            onClick={isDisabled[tab?.key] ? null : (e) => {
                                setActiveParentTab(tab.targetId); // Manually activate tab immediately
                                scrollToSection(tab.targetId);     // Then scroll
                            }}
                        >
                            <div style={{ boxShadow: activeParentTab === tab.targetId ? '0px 0px 4px 0px var(--primary-color)' : '' }} className={`aspect-square rounded-full border border-[#ECEEEF] h-[28px] w-[28px] flex items-center justify-center ${activeParentTab === tab.targetId ? 'selectedTab bg-primary text-white border border-primary    ' : 'text-fontBlack'}`}>{tab.icon}</div>
                            <div>{tab.label}</div>
                        </div>
                    </Tooltip>
                )})}
            </div>
        )
    }

    return (
        <div className='df-view-img viewProductDetails viewProductDetailsV2'>
            {renderHeaderComponent()}

            {/* Render the content of view details in two portion */}
            <div className='dfv-body !h-[calc(100%-85px)]'>
                {/* Render the details section */}
                {/* Render tabs */}
                {/* {viewPageType == "product" && renderTabsSection()} */}

                <div ref={scrollableContainerRef} className='h-100 overflow-auto pt-[20px] px-[15px]'>

                    {renderDetails()}
                </div>
            </div>
        </div>
    )
}

export default ViewProductDetailsV2